import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import type { PlayerProfileFormProps } from './types';
import { asNumber, asString, setNumber, setString } from './helpers';

export const VolleyballPlayerProfileForm: React.FC<PlayerProfileFormProps> = ({ value, onChange }) => (
  <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
    <FormControl fullWidth size="small">
      <InputLabel>Позиция</InputLabel>
      <Select
        value={asString(value.position)}
        label="Позиция"
        onChange={(e) => setString(value, 'position', e.target.value, onChange)}
      >
        <MenuItem value="setter">Связующий</MenuItem>
        <MenuItem value="outside_hitter">Доигровщик</MenuItem>
        <MenuItem value="opposite">Диагональный</MenuItem>
        <MenuItem value="middle_blocker">Центральный блокирующий</MenuItem>
        <MenuItem value="libero">Либеро</MenuItem>
      </Select>
    </FormControl>
    <TextField label="Номер" size="small" value={asNumber(value.number)} onChange={(e) => setNumber(value, 'number', e.target.value, onChange)} />
    <TextField label="Рост (см)" size="small" value={asNumber(value.heightCm)} onChange={(e) => setNumber(value, 'heightCm', e.target.value, onChange)} />
    <TextField label="Высота атаки (см)" size="small" value={asNumber(value.spikeReachCm)} onChange={(e) => setNumber(value, 'spikeReachCm', e.target.value, onChange)} />
    <TextField label="Высота блока (см)" size="small" value={asNumber(value.blockReachCm)} onChange={(e) => setNumber(value, 'blockReachCm', e.target.value, onChange)} />
  </Box>
);
